import React from "react";

import Default from "./Default";

const Feedback = () => {
    return (
        <Default />
    )
};

export default Feedback;